import { InputProps, InputRef } from 'antd'
import { useCustomInput } from 'shared/libs/hooks/useCustomInput'

import { useRef } from 'react'

import CustomInput from 'shared/ui/Form/CustomInput/CustomInput'
import TextFiled from 'shared/ui/Form/TextFiled'

export type CustomTextFieldProps = InputProps & {
  wrapperClassname?: string
  placeholderClassname?: string
}

const CustomTextFiled = ({
  placeholder,
  className,
  value,
  wrapperClassname,
  placeholderClassname,
  ...props
}: CustomTextFieldProps) => {
  const inputRef = useRef<InputRef>(null)
  const { isFocus, setIsFocus, handleFocus, handleBlur } = useCustomInput()

  return (
    <CustomInput
      value={value}
      placeholder={placeholder}
      childrenRef={inputRef}
      wrapperClassname={wrapperClassname}
      placeholderClassname={placeholderClassname}
      isFocus={isFocus}
      setIsFocus={setIsFocus}
    >
      <TextFiled
        withPlaceholder={false}
        ref={inputRef}
        value={value}
        onBlur={handleBlur}
        onFocus={handleFocus}
        rootClassName={`px-0 py-0 !border-none rounded-[0px] !shadow-none focus:shadow-none focus:border-none w-full ${className}`}
        {...props}
      />
    </CustomInput>
  )
}

export default CustomTextFiled
